module.exports = __webpack_public_path__ + "static/wamdigital-e6665e6026aca5d14cf5b4d2c542c368.png";